import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { ErrorScreenService } from './error-screen.service';

// Replaces Angular's default ErrorHandler (a console.error and otherwise
// nothing — a crash just leaves whatever half-rendered page was on screen,
// or a blank one) with a branded full-screen message, so a genuine bug
// doesn't dump a stack trace in front of a guard/receptionist mid-shift.
// Takes an Injector rather than injecting ErrorScreenService directly —
// ErrorHandler is instantiated very early in the bootstrap process, before
// most other providers are safely resolvable.
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) { }

  handleError(error: any): void {
    console.error(error);

    const message = (error && error.message) || '';
    if (message.indexOf('Loading chunk') !== -1 || message.indexOf('ChunkLoadError') !== -1) {
      // A stale cached bundle referencing a chunk that no longer exists
      // after a new deploy — a reload fetches the current build instead of
      // showing an error screen for something a refresh just fixes.
      window.location.reload();
      return;
    }

    try {
      this.injector.get(ErrorScreenService).show();
    } catch (e) {
      // Nothing further can be safely done if the error screen's own
      // service can't be resolved.
    }
  }
}
